var RequestorEnum;
(function (RequestorEnum) {
    RequestorEnum["AccountManagement"] = "account_management";
    RequestorEnum["ImplementationTeam"] = "implementation_team";
    RequestorEnum["Other"] = "other";
})(RequestorEnum || (RequestorEnum = {}));
export var requestorOptions = [
    { label: 'Account Management', value: RequestorEnum.AccountManagement },
    { label: 'Implementation Team', value: RequestorEnum.ImplementationTeam },
    { label: 'Other', value: RequestorEnum.Other }
];
var EngineeringStatusEnum;
(function (EngineeringStatusEnum) {
    EngineeringStatusEnum["NotSubmitted"] = "not_submitted";
    EngineeringStatusEnum["Submitted"] = "submitted";
    EngineeringStatusEnum["InProgress"] = "in_progress";
    EngineeringStatusEnum["Complete"] = "complete";
})(EngineeringStatusEnum || (EngineeringStatusEnum = {}));
export var engineeringStatusOptions = [
    { label: 'Not Submitted', value: EngineeringStatusEnum.NotSubmitted },
    { label: 'Submitted', value: EngineeringStatusEnum.Submitted },
    { label: 'In Progress', value: EngineeringStatusEnum.InProgress },
    { label: 'Complete', value: EngineeringStatusEnum.Complete }
];
